module.exports = __webpack_public_path__ + "img/meeting.17353227.svg";